import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { X } from "react-feather";
import useSrlHelper from "../../hooks/useSrlHelper";

const AssetBatteryFilter = (props) => {
  const {
    column: { filterValue, setFilter },
  } = props;

  const filterPrefix = "$BATTERY=";
  const filterSeperator = "|";
  // const filterBlankLabel = "[BLANKS]";

  const [selectValue, setSelectValue] = useState("");
  const [localValue, setLocalValue] = useState("");
  const [localValueInvalid, setLocalValueInvalid] = useState(false);
  const [placeholder, setPlaceholder] = useState("");
  const [disableValue, setDisableValue] = useState(false);

  const { getFilterTypeOptions } = useSrlHelper();

  const filterTypeOptions = useMemo(
    () => getFilterTypeOptions(),
    [getFilterTypeOptions]
  );

  const parseFilterValue = useCallback(() => {
    if (
      filterValue &&
      typeof filterValue === "string" &&
      filterValue.startsWith(filterPrefix)
    ) {
      var rightSide = filterValue.substring(filterPrefix.length);

      var parts = rightSide.split(filterSeperator);

      if (parts.length > 0) {
        setSelectValue(parts[0]);
      }
      if (parts.length === 2) {
        setLocalValue(parts[1]);
      }
      // if (parts.length === 3) {
      //   setLocalValue(parts[1] + "-" + parts[2]);
      // }
    }
  }, [filterValue]);

  useEffect(() => {
    parseFilterValue();
  }, [parseFilterValue]);

  // useEffect(() => {
  //   setSelectValue(
  //     filterValue && filterValue.length >= 3 ? filterValue[1] : "0"
  //   );
  //   setLocalValue(
  //     filterValue && filterValue.length > 3 ? filterValue.substring(3) : ""
  //   );
  // }, [filterValue]);

  useEffect(() => {
    var filterTypeOption = filterTypeOptions.find(
      (v, i) => v.value === selectValue
    );
    if (filterTypeOption) {
      setPlaceholder(filterTypeOption.placeholder);
      setDisableValue(filterTypeOption.disableValue);
    }

    if (selectValue !== "") {
      var v = localValue;
      if (!filterTypeOption.disableValue) {
        let isValid = RegExp(filterTypeOption.regExp).test(v);
        setLocalValueInvalid(!isValid);
        if (isValid) {
          setFilter(
            filterPrefix + filterTypeOption.value + filterSeperator + v
          );
        } else {
          setFilter("");
        }
      } else {
        setFilter(filterPrefix + filterTypeOption.value);
        setLocalValueInvalid(false);
      }
    } else {
      setFilter("");
    }
  }, [filterTypeOptions, localValue, selectValue]);

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
    setLocalValue("");
    e.preventDefault();
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="p-0 m-0 flex-grow-1">
        <Form.Group className="flex-grow-1">
          <Form.Select
            className=""
            name="filterType"
            id="filterType"
            value={selectValue}
            onChange={handleSelectChange}
          >
            {filterTypeOptions.map((v, i) => {
              return (
                <option key={`filterType${i}`} value={v.value}>
                  {v.text}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </div>
      <div className="p-0 m-0">
        <Form.Group className="p-0 m-0">
          <Form.Control
            type="text"
            placeholder={placeholder}
            value={localValue}
            disabled={disableValue}
            onChange={(e) => {
              setLocalValue(e.target.value);
            }}
            className={{
              border: localValueInvalid,
              "border-3": localValueInvalid,
              "border-danger": localValueInvalid,
            }}
          />
        </Form.Group>
      </div>
      <div className="flex-shrink-1">
        <Button
          variant=""
          className="p-0 m-0"
          onClick={() => {
            setSelectValue("");
            setLocalValue("");
            setLocalValueInvalid(false);
            setFilter("");
          }}
        >
          <X />
        </Button>
      </div>
      {/* <span style={{ cursor: "pointer" }} onClick={() => { setLessMore(!lessMore); }} >{!lessMore ? "less than" : "more than"}</span> */}
    </div>
  );
};

export default AssetBatteryFilter;
